import { mergeStyles } from '../../../internal/utils';
import * as inputWrapperStyles from '../../../internal/styles/inputWrapperAdornment.css';
import * as mainStyles from './styles.css';
export function getInputAdornmentStyles(size) {
  return mergeStyles(mainStyles, inputWrapperStyles, require("./size/".concat(size, ".css")));
}